"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterButtons = void 0;
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var React = require("react");
var FooterButtons = function (props) {
    return (React.createElement("div", { className: "tender-card-documents-modal-footer" },
        React.createElement(sok_ui_1.Button, { className: "close-button", size: 'medium', color: 'black', text: (0, translation_1.getLocalization)('global/close'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-times-circle' }), onClick: props.closeModal }),
        ' '));
};
exports.FooterButtons = FooterButtons;
